module.exports = __webpack_public_path__ + "img/logo-icon.ade0b973.png";